var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUpdate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#ic-update_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 1 1 0-2h5V4a1 1 0 0 1 1-1M0 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H2v5a1 1 0 1 1-2 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.217 4.317a8 8 0 0 0-9.764 5.017 1 1 0 1 1-1.886-.668 10 10 0 0 1 16.489-3.744l4.629 4.35a1 1 0 0 1-1.37 1.457l-4.64-4.36-.022-.022a8 8 0 0 0-3.436-2.03M.271 13.315a1 1 0 0 1 1.414-.044l4.64 4.36.022.022a8 8 0 0 0 13.2-2.987 1 1 0 0 1 1.886.668 10 10 0 0 1-16.489 3.744l-4.629-4.35a1 1 0 0 1-.044-1.413"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-update_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export default SvgIcUpdate;